/// <amd-module name="Build/Shared/Components/Histogram/index" />
export * from "./Histogram";
export { IHistogramItem, IHistogramProps, IHistogramState } from "./Histogram.types";
